import * as React from 'react'
import dynamic from 'next/dynamic'

import { HorizontalAlignment, i18n } from '@thg-commerce/enterprise-core'
import { Grid, GridItem } from '@thg-commerce/gravity-system'

import { CoverageCalculatorForm } from './CoverageCalculatorForm'
import {
  Title,
  Subtitle,
  AdditionalInfoText,
  InstructionsTitle,
  CalculatorGrid,
  AdditionalInfoTitle,
  InstructionsText,
  GravityPlusIcon,
  IconGridItem,
  CalculatorInfoContainer,
  InstructionsButton,
} from './styles'

const GravityMinus = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Minus'),
)

export interface CoverageCalculatorProps {
  title: {
    text?: string
    textAlign?: HorizontalAlignment
  }
  subtitle?: string
  className?: string
  additionalInfoTitle?: string
  additionalInfoText?: string
  instructionsTitle?: string
  instructionsText?: string
  paintCoverage?: number
  buyButtonUrl?: string
}

export const CoverageCalculator = (props: CoverageCalculatorProps) => {
  const [
    openInstructionsOnMobile,
    setOpenInstructionsOnMobile,
  ] = React.useState(false)

  const i18nText = {
    openInstructions: i18n('coveragecalculator.open.instructions.text'),
    closeInstructions: i18n('coveragecalculator.close.instructions.text'),
  }

  return (
    <div className={props.className}>
      {props.title.text && (
        <Title alignment={props.title.textAlign}>{props.title.text}</Title>
      )}

      <CalculatorGrid rowGap={8}>
        <GridItem colSpan={[12, 12, 6, 6]} rowStart={[2, 2, 1, 1]}>
          {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
          <CoverageCalculatorForm
            paintCoverage={props.paintCoverage ?? 10}
            buyButtonUrl={props.buyButtonUrl}
          />
        </GridItem>
        <GridItem colSpan={[12, 12, 6, 6]} rowStart={1}>
          {props.additionalInfoTitle && (
            <AdditionalInfoTitle>
              {props.additionalInfoTitle}
            </AdditionalInfoTitle>
          )}
          {props.additionalInfoText && (
            <AdditionalInfoText
              __dangerouslyAllowedTags={['b']}
              content={props.additionalInfoText}
            />
          )}
          {props.instructionsText && (
            <CalculatorInfoContainer>
              <Grid>
                {props.instructionsTitle && (
                  <InstructionsTitle colSpan={6}>
                    {props.instructionsTitle}
                  </InstructionsTitle>
                )}
                <IconGridItem colSpan={6}>
                  {openInstructionsOnMobile ? (
                    <InstructionsButton
                      onClick={() => setOpenInstructionsOnMobile(false)}
                      aria-label={i18nText.openInstructions}
                      data-testid="close-instructions-button"
                      emphasis="low"
                    >
                      <GravityMinus />
                    </InstructionsButton>
                  ) : (
                    <InstructionsButton
                      onClick={() => setOpenInstructionsOnMobile(true)}
                      aria-label={i18nText.closeInstructions}
                      data-testid="open-instructions-button"
                      emphasis="low"
                    >
                      <GravityPlusIcon color="default" />
                    </InstructionsButton>
                  )}
                </IconGridItem>
              </Grid>
              <InstructionsText
                __dangerouslyAllowedTags={['b']}
                content={props.instructionsText}
                showInstructionsOnMobile={openInstructionsOnMobile}
                data-testid="instructions-coverage-calculator-text"
              />
            </CalculatorInfoContainer>
          )}
        </GridItem>
      </CalculatorGrid>
    </div>
  )
}
